"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XHREventDrivenServer = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const utils_1 = require("./utils");
class XHREventDrivenServer extends web_ui_framework_1.HttpEventDrivenServer {
    constructor(_eventBus, API) {
        super(_eventBus);
        this.API = API;
        this.doRequest = (request) => {
            if (!Object.values(web_ui_framework_1.RequestMethod).includes(request.method)) {
                return Promise.reject((0, web_ui_framework_1.createFetchError)(request.id, `XHREventDrivenServer Error: The method "${request.method}" is not supported`));
            }
            let xhrRequest;
            try {
                xhrRequest = (0, utils_1.createRequest)(request);
            }
            catch (error) {
                return Promise.reject((0, web_ui_framework_1.createFetchError)(request.id, `XHREventDrivenServer Error: There was an error when processing your request: ${error}`));
            }
            const { method, url, body, xhrOptions } = xhrRequest;
            return this.sendRequest({
                method,
                url,
                body,
                xhrOptions,
            })
                .then(async (response) => {
                // TODO: map responseType to BodyType or we should receive a BodyType in the response
                const contentType = response.responseHeaders['content-type'];
                const fetchResponse = await (0, utils_1.createResponse)(request.id, response, contentType || web_ui_framework_1.MediaType.JSON // TODO: do this dynamically
                );
                return fetchResponse;
            })
                .catch(async (error) => {
                return (0, web_ui_framework_1.createFetchError)(request.id, 'XHREventDrivenServer Error: XHR "fetch" method failed');
            });
        };
    }
    sendRequest(params) {
        if (params.method === web_ui_framework_1.RequestMethod.GET) {
            return this.API[params.method](params.url, params.xhrOptions);
        }
        return this.API[params.method](params.url, params.body, params.xhrOptions);
    }
}
exports.XHREventDrivenServer = XHREventDrivenServer;
//# sourceMappingURL=XHREventDrivenServer.js.map